import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

export function useLanguage() {
  const { i18n } = useTranslation();
  const formatOptionsByLang = useCallback(
    (options, formatParams) =>
      options.map((opt) => {
        if (formatParams?.newPropertyKey)
          return {
            value: `${
              formatParams?.valueKey
                ? opt[formatParams.valueKey]
                : opt.referenceId
            }`,
            label:
              i18n.language === "ka"
                ? opt.referenceNameGe
                : opt.referenceNameEn,
            [formatParams.newPropertyKey]:
              opt[formatParams.newPropertyValueKeyFormOptions],
          };
        else
          return {
            value: `${
              formatParams?.valueKey
                ? opt[formatParams.valueKey]
                : opt.referenceId
            }`,
            label:
              i18n.language === "ka"
                ? opt.referenceNameGe
                : opt.referenceNameEn,
          };
      }),
    [i18n.language]
  );
  return {
    isContentGeorgian: i18n.language === "ka",
    contentLanguage: i18n.language,
    formatOptionsByLang: formatOptionsByLang,
  };
}
